import { Input, InputGroup } from "@chakra-ui/react";
import PasswordVisibilityToggle from "./PasswordVisibilityToggle";

function PasswordInput({ isVisible, onToggle, size = "md", ...inputProps }) {
  return (
    <InputGroup size={size}>
      <Input
        {...inputProps}
        pe="2.75rem"
        type={isVisible ? "text" : "password"}
      />
      <PasswordVisibilityToggle isVisible={isVisible} onToggle={onToggle} />
    </InputGroup>
  );
}

export default PasswordInput;
